import React from 'react';
import { ShieldIcon, RefreshCwIcon, CheckCircleIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-106">
      <div className="max-w-6xl mx-auto" data-id="element-107">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-108">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-brand-red rounded-full mb-6" data-id="element-109">
            <ShieldIcon className="w-10 h-10 text-white" aria-hidden="true" data-id="element-110" />
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-brand-black mb-4" data-id="element-111">
            Try CrownControl™ Risk-Free for 180 Days
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-112">
            We're so confident you'll see results, we offer an industry-leading
            6-month guarantee
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-113">
          {/* Product Image Placeholder */}
          <div className="bg-gray-100 rounded-2xl overflow-hidden" data-id="element-114">
            <img src="https://cdn.magicpatterns.com/uploads/sv3BAqLzBZCK2Ser5knZWd/ChatGPT_Image_Feb_19,_2026,_03_27_07_PM.png" alt="CrownControl Pro red light therapy hat with 272 medical-grade LEDs" className="w-full h-auto" data-id="element-115" />
          </div>

          {/* Guarantee Points */}
          <div className="space-y-8" data-id="element-116">
            <div className="flex items-start gap-4" data-id="element-117">
              <div className="bg-green-100 rounded-lg p-3 flex-shrink-0" data-id="element-118">
                <CheckCircleIcon className="w-8 h-8 text-green-600" aria-hidden="true" data-id="element-119" />
              </div>
              <div data-id="element-120">
                <h3 className="text-2xl font-bold text-brand-black mb-2" data-id="element-121">
                  Full 180-Day Money-Back Guarantee
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-122">
                  Use CrownControl™ for a full 6 months. If you're not
                  completely satisfied with your results, return it for a full
                  refund—no questions asked.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-123">
              <div className="bg-green-100 rounded-lg p-3 flex-shrink-0" data-id="element-124">
                <RefreshCwIcon className="w-8 h-8 text-green-600" aria-hidden="true" data-id="element-125" />
              </div>
              <div data-id="element-126">
                <h3 className="text-2xl font-bold text-brand-black mb-2" data-id="element-127">
                  Easy Returns, No Hassle
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-128">
                  Simply contact our support team and we'll process your return
                  immediately. We'll even cover return shipping.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-129">
              <div className="bg-green-100 rounded-lg p-3 flex-shrink-0" data-id="element-130">
                <ShieldIcon className="w-8 h-8 text-green-600" aria-hidden="true" data-id="element-131" />
              </div>
              <div data-id="element-132">
                <h3 className="text-2xl font-bold text-brand-black mb-2" data-id="element-133">
                  Protected Purchase
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-134">
                  Your investment is 100% protected. We stand behind our product
                  because we know it works.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="pt-6" data-id="element-135">
              <a href="https://offer.crowncontrol.shop/" className="block w-full bg-brand-red text-white px-8 py-5 rounded-lg font-bold text-xl hover:bg-red-700 transition-colors shadow-lg text-center" aria-label="Get CrownControl" data-id="element-136">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}